var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('app-header',{attrs:{"module-navigation":_vm.navigation,"module-name":"Facturation"}}),_vm._v(" "),_c('main',{staticClass:"with-tabs",attrs:{"id":"page-main"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0147ae52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/invoicing/Index.vue
// module id = 792
// module chunks = 0